import { ICellEditorComp, ICellEditorParams, ICellRendererComp, ICellRendererParams } from "ag-grid-community";
import React, { ChangeEvent, Component, RefObject } from "react";

import styles from "./styles.less";


interface MultiSelectEditorProps extends ICellEditorParams {
  options: string[] | Record<string, string>;
}

interface MultiSelectEditorState {
  value: string[];
}

export class MultiSelectEditor
  extends Component<MultiSelectEditorProps, MultiSelectEditorState>
  implements ICellEditorComp {
  private readonly multiSelectRef: RefObject<
    HTMLSelectElement
  > = React.createRef();

  constructor(props: MultiSelectEditorProps) {
    super(props);

    this.state = { value: props.value };
  }

  afterGuiAttached() {
    // get ref from React component
    const eInput = this.multiSelectRef.current;

    if (eInput) {
      eInput.focus();
    }
  }

  getGui() {
    return this.multiSelectRef.current as HTMLSelectElement;
  }

  getHeight() {
    const { options } = this.props;
    let items = 1;

    switch (options.constructor) {
      case Array:
        items = (options as string[]).length;
        break;
      case Object:
        items = Object.entries(options).length;
        break;
    }

    return 17 * items + 3;
  }

  getValue() {
    return this.state.value;
  }

  isCancelAfterEnd() {
    return false;
  }

  isCancelBeforeStart() {
    return false;
  }

  isPopup() {
    return true;
  }

  updateValue = (e: ChangeEvent<HTMLSelectElement>) => {
    const value = Array.from(e.target.options)
      .filter(e => e.selected)
      .map(e => e.value);
    this.setState({ value });
  };

  render() {
    const value =
      this.state.value.length > 0 ? this.state.value : this.props.value;
    const options = this.renderOptions();

    return (
      <div tabIndex={1}>
        <select
          className={styles.multiSelect}
          multiple
          onChange={this.updateValue}
          ref={this.multiSelectRef}
          style={{
            height: this.getHeight()
          }}
          tabIndex={1}
          value={value}
        >
          {options}
        </select>
      </div>
    );
  }

  renderOptions() {
    const { options } = this.props;
    switch (options.constructor) {
      case Array:
        return (options as string[]).map((e, i) => (
          <option key={i} value={e}>
            {e}
          </option>
        ));
      case Object:
        return Object.entries(options).map(([value, label], i) => (
          <option key={i} value={value}>
            {label}
          </option>
        ));
      default:
        return <option disabled>No options provided</option>;
    }
  }
}

interface MultiSelectCellProps extends ICellRendererParams {}

interface MultiSelectCellState {
  value: string[];
}

export class MultiSelectCellRenderer
  extends Component<MultiSelectCellProps, MultiSelectCellState>
  implements ICellRendererComp {
  private readonly divRef: RefObject<HTMLDivElement> = React.createRef();

  state = {
    value: []
  };

  getGui() {
    return this.divRef.current as HTMLDivElement;
  }

  refresh(params: ICellRendererParams) {
    this.setState({ value: params.value });
    return true;
  }

  render() {
    const value =
      this.state.value.length > 0 ? this.state.value : this.props.value;
    return <div ref={this.divRef}>{value.join(", ")}</div>;
  }
}
